module.exports = __webpack_public_path__ + "static/media/UW_Horizontal_Logo_Full.b6bada34.png";